import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Text, Stack, mergeStyles } from '@fluentui/react';
import { ExternalLink } from '@shared/components/externalLink';
import { Constants } from '@shared/utils/constants';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { logger } from '@src/logger';
import { isD365App } from '@shared/utils/appUtils';
import { appHistory } from '@src/shared/routerHistory';
export const nextStepsHighlitedTextClass = mergeStyles({
    fontWeight: '600'
});
const logAdminCenterClick = ()=>{
    var _appHistory_location;
    const payload = {
        page: (_appHistory_location = appHistory.location) === null || _appHistory_location === void 0 ? void 0 : _appHistory_location.pathname,
        action: Constants.Telemetry.Action.Click,
        actionModifier: Constants.Telemetry.ActionModifier.AdminCenter
    };
    SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
    logger.info('', payload);
};
function renderD356(context) {
    return /*#__PURE__*/ _jsxs(Stack, {
        children: [
            /*#__PURE__*/ _jsx(Stack.Item, {
                children: /*#__PURE__*/ _jsx(Text, {
                    className: "new-checkout-step-header ms-fontWeight-semibold displayBlock mt-20",
                    children: context.loc('Checkout_OrderConfirmation_NextStepText', 'Next steps')
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                children: /*#__PURE__*/ _jsxs(Text, {
                    children: [
                        context.loc('Checkout_OrderConfirmation_NowAssingTheLicensesText', 'Now, assign the licenses you purchased to users in your tenant via'),
                        /*#__PURE__*/ _jsx(ExternalLink, {
                            "data-bi-id": Constants.TeachingBubblePurchaseConfirmation.AdminCenterLinkId,
                            "data-bi-name": Constants.TeachingBubblePurchaseConfirmation.AdminCenterLinkName,
                            className: "c-hyperlink link-double-sided-padding",
                            href: Constants.AdminCenterLink,
                            accessibilityEnabled: true,
                            target: "_blank",
                            onClick: logAdminCenterClick,
                            children: context.loc('Checkout_OrderConfirmation_AdminCenterLinkText', 'Admin center.')
                        }),
                        context.loc('Checkout_OrderConfirmation_D365FromThereYouCanProceedText', 'From there you can proceed to install this app.')
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Stack.Item, {
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        children: context.loc('Checkout_OrderConfirmation_ToManageYourLicensesText', 'To manage your licenses anytime, click on your account at the top right, open')
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: `${nextStepsHighlitedTextClass}`,
                        children: context.loc('Checkout_OrderConfirmation_AdminCenterText', ' Admin center')
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        children: context.loc('Checkout_OrderConfirmation_AndGoToText', ' and go to')
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: `${nextStepsHighlitedTextClass}`,
                        children: context.loc('Checkout_OrderConfirmation_LicensesText', ' Licenses.')
                    })
                ]
            })
        ]
    });
}
function renderPbiVisuals(context) {
    return /*#__PURE__*/ _jsxs(Stack, {
        children: [
            /*#__PURE__*/ _jsx(Stack.Item, {
                children: /*#__PURE__*/ _jsx(Text, {
                    className: "new-checkout-step-header ms-fontWeight-semibold displayBlock mt-20",
                    children: context.loc('Checkout_OrderConfirmation_NextStepText', 'Next steps')
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                children: /*#__PURE__*/ _jsxs("ul", {
                    className: "next-steps-list",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            children: /*#__PURE__*/ _jsxs(Text, {
                                children: [
                                    context.loc('Checkout_OrderConfirmation_PbivGoToText_Part1', 'Go to'),
                                    /*#__PURE__*/ _jsx(ExternalLink, {
                                        "data-bi-id": Constants.TeachingBubblePurchaseConfirmation.AdminCenterLinkId,
                                        "data-bi-name": Constants.TeachingBubblePurchaseConfirmation.AdminCenterLinkName,
                                        className: "c-hyperlink link-double-sided-padding",
                                        href: Constants.AdminCenterLink,
                                        accessibilityEnabled: true,
                                        target: "_blank",
                                        onClick: logAdminCenterClick,
                                        children: context.loc('Checkout_OrderConfirmation_PbivAdminCenterLinkText', 'Admin center')
                                    }),
                                    context.loc('Checkout_OrderConfirmation_PbivGoToText_Part2', 'to assign the purchase licenses to users in your tenant.')
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            children: /*#__PURE__*/ _jsx(Text, {
                                children: context.loc('Checkout_OrderConfirmation_PbivRefreshThePowerBI', 'Refresh the Power BI service, or close and re-open the desktop app.')
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Stack.Item, {
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        children: context.loc('Checkout_OrderConfirmation_ToManageYourLicensesText', 'To manage your licenses anytime, click on your account at the top right, open')
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: `${nextStepsHighlitedTextClass}`,
                        children: context.loc('Checkout_OrderConfirmation_AdminCenterText', ' Admin center')
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        children: context.loc('Checkout_OrderConfirmation_AndGoToText', ' and go to')
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: `${nextStepsHighlitedTextClass}`,
                        children: context.loc('Checkout_OrderConfirmation_LicensesText', ' Licenses.')
                    })
                ]
            })
        ]
    });
}
const BagNextStepsComponent = ({ context, app })=>{
    return isD365App(app) ? renderD356(context) : renderPbiVisuals(context);
};
export const BagNextSteps = BagNextStepsComponent;
